<style lang="scss" scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.md-max-size {
  max-width: 400px;
}
</style>

<template>
<navigation-layout ref='navigationlayout'>
  <main>
    <form novalidate class="md-layout md-alignment-top-center" @submit.prevent="validateLogin">
      <div class="md-layout-item md-max-size md-medium-size-33 md-small-size-50 md-xsmall-size-100">
          <div class="md-title">Login</div>
            <field fieldName="email" ref="email" fieldType="email" :validations="{required: true, email: true}" :fieldValue=form.email fieldLabel="Email"
              fieldId="email" :sending="sending" @setfield="setFormField($event)" />
            <field fieldName="password" ref="password" fieldType="password" :validations="{required: true,min:6}" :fieldValue=form.password fieldLabel="Password"
              fieldId="password" :sending="sending" @setfield="setFormField($event)" />
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
        <md-checkbox v-model="rememberme">Remember me</md-checkbox>
        <md-button type="submit" class="md-raised md-primary" :disabled="sending">Login</md-button>
      </div>
    </form>
  </main>
</navigation-layout>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import NotificationService from '@/services/notificationService'
import router from '@/router'
import Field from '@/components/elements/field'

export default {
  name: 'login',
  data: () => ({
    form: {
      email: null,
      password: null
    },
    rememberme: false,
    sending: false
  }),
  components: { NavigationLayout, Field },
  created: async function () {
    if (!RepositoryService.session.rememberme) {
      await RepositoryService.session.clear()
    }
  },
  methods: {
    async validateLogin () {
      var results = []
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].validateField) {
          results.push(await this.$refs[property].validateField())
        }
      }
      var canSave = results.every((value) => { return value })
      if (canSave) {
        this.loginUser()
        this.sending = true
      }
    },
    setFormField (fieldObj) {
      this.form[fieldObj.fieldName] = fieldObj.fieldValue
    },
    clearForm () {
      this.form.email = null
      this.form.password = null
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].clearField) {
          this.$refs[property].clearField()
        }
      }
    },
    async loginUser () {
      this.sending = true
      await NotificationService.manageNotification(this, await RepositoryService.loginAdmin(this.form.email, this.form.password, this.rememberme), this.callback)
      this.sending = false
    },
    callback (data) {
      this.clearForm()
      this.$refs.navigationlayout.setNotification(`User logged successfully - ${this.form.email}`)
      if (this.$route.query.redirect) {
        router.push({ path: this.$route.query.redirect })
      } else {
        router.push({ name: 'selectbillingcompany' })
      }
    }
  }
}
</script>
